<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">{{ title }}</h3>
            </div>
            <div class="kt-portlet__head-toolbar">
                <button type="button" class="btn btn-secondary btn-sm mr-2" (click)="onBackToList()"><i class="fas fa-arrow-left"></i>Back to List</button>
                <button *ngIf="isEditing && canCreate" type="button" class="btn btn-brand btn-sm" (click)="onCreateNew()"><i class="fas fa-plus"></i>Create New</button>
            </div>
        </div>

        <!-- Step list + step, as 3.2.2 Promotion Setup: global .promotion-stepper styles. -->
        <div class="promotion-stepper">
            <ng-container *ngIf="loading || saving">
                <div class="spinner-wrapper">
                    <mat-progress-spinner mode="indeterminate" class="spinner" diameter="20"></mat-progress-spinner>
                </div>
            </ng-container>
            <div class="row m-0">
                <div class="sidebar-column p-0">
                    <div class="sidebar">
                        <ul>
                            <li *ngFor="let step of steps" [class.active]="step === currentStep" (click)="onToStep(step)">
                                <span [ngClass]="stepDotClass(step)">
                                    <i *ngIf="stepDotClass(step) === 'passed-dot'" class="fas fa-check"></i>
                                    <i *ngIf="stepDotClass(step) === 'red-dot'" class="fa fa-times"></i>
                                </span>
                                <span *ngIf="stepChanged(step)" class="kt-badge kt-badge--warning kt-badge--dot mr-2" matTooltip="Changed, not saved"></span>
                                {{ stepLabels[step] }}
                                <span *ngIf="step === STEP_PLAYERS && isEditing" class="kt-badge kt-badge--brand kt-badge--inline ml-2">{{ membersCount + stagedAdd.size - stagedRemove.size }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="content-column p-0">
                    <div class="content" *ngIf="!loading">
                        <kt-bet-limit-group-info-step [hidden]="currentStep !== STEP_INFO"
                            [form]="form" [providers]="providers" [mode]="mode" [groupCode]="groupCode">
                        </kt-bet-limit-group-info-step>

                        <kt-bet-limit-limits-step [hidden]="currentStep !== STEP_LIMITS"
                            [provider]="provider" [currencies]="currencies" [cells]="cells" [defaultCells]="defaultCells"
                            [isDefault]="mode === 'default'" [readonly]="readonly" [revision]="revision" (changed)="onChanged()">
                        </kt-bet-limit-limits-step>

                        <kt-bet-limit-players-step *ngIf="mode !== 'default'" [hidden]="currentStep !== STEP_PLAYERS"
                            [groupId]="groupId" [groupName]="form.get('name').value" [provider]="provider"
                            [membersCount]="membersCount" [stagedAdd]="stagedAdd" [stagedRemove]="stagedRemove"
                            [readonly]="readonly" [loadCount]="loadCount" [revision]="revision" (changed)="onChanged()">
                        </kt-bet-limit-players-step>

                        <div class="actions">
                            <button class="promo-back-button" mat-button (click)="onBack()" [disabled]="currentStep === steps[0]">
                                <i class="fas fa-arrow-left"></i>Back
                            </button>
                            <span *ngIf="isEditing && hasUnsavedChanges" class="ml-auto mr-3 align-self-center text-warning">Unsaved changes</span>
                            <span *ngIf="!canSave" class="ml-auto align-self-center text-muted">View only: you have no permission to {{ isEditing ? 'edit' : 'create' }} groups.</span>
                            <button class="promo-next-button" mat-button (click)="onNext()" *ngIf="!isEditing && !isLastStep && canSave"
                                [disabled]="saving" [class.ml-auto]="!(isEditing && hasUnsavedChanges)">
                                Next
                            </button>
                            <!-- Same rule as 3.2.2: edit shows Update on every step (one save writes all
                                 steps); create submits from the last step only. -->
                            <button class="promo-next-button" mat-button (click)="onSubmit()" *ngIf="canSave && (isEditing || isLastStep)"
                                [class.ml-auto]="!(isEditing && hasUnsavedChanges)"
                                [disabled]="saving || loading || (isEditing && !hasUnsavedChanges)">
                                {{ saving ? 'Saving...' : (isEditing ? 'Update' : 'Submit') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
